module.exports = __webpack_public_path__ + "media/images/lb/012-33373e0d3f2b571e49ffec083b2af810.svg";